<template>
  <div>
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>管理员管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片开始 -->
    <el-card class="conentBox">
      <el-row class="conentRow">
        <el-col :span="24" class="scenicBtn">
          <el-button type="primary" plain @click="editFn()">
            <i class="iconfont icon-jiahao"></i>
            添加管理员
          </el-button>
        </el-col>
      </el-row>
      <el-table
        :data="adminTable"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="UserName" label="用户名"></el-table-column>
        <el-table-column prop="rule_name" label="所属角色"></el-table-column>
        <el-table-column prop="Login_ip" label="最后登录IP"></el-table-column>
        <el-table-column prop="Login_time" label="最后登录时间"></el-table-column>
        <el-table-column prop="E_mail" label="Email"></el-table-column>
        <el-table-column prop="Name" label="真实姓名"></el-table-column>
        <!-- <el-table-column prop="UserID" label="岗位"></el-table-column> -->
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <el-button class="editCol" type="text" @click="editFn(scope.row)">修改</el-button>
            <el-button type="text" @click="delFn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="adminPar.page"
          :page-size="8"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{adminPar.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="adminPar.page"  @current-change="handleCurrentChange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 卡片结束 -->

    <!-- 信息上下线弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="editDialogVisible"
      :before-close="editHandleClose"
      width="33%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <el-form class="editForm" ref="form" label-width="88px" :model="editData">
        <el-form-item label="用户名:">
          <span class="absPosiA">*</span>
          <el-input v-model="editData.UserName"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名:">
          <span class="absPosiB">*</span>
          <el-input v-model="editData.realName"></el-input>
        </el-form-item>
        <el-form-item label="手机号:">
          <span class="absPosiB">*</span>
          <el-input v-model="editData.Phone"></el-input>
        </el-form-item>
        <!-- <el-form-item label="岗位:">
          <el-input v-model="editData.post"></el-input>
        </el-form-item>-->
        <el-form-item label="密码:">
          <span class="absPosiD">*</span>
          <el-input type="password" v-model="editData.passWord"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:">
          <span class="absPosiE">*</span>
          <el-input type="password" v-model="editData.surePassWord"></el-input>
        </el-form-item>
        <el-form-item label="Email:">
          <span class="absPosiF">*</span>
          <el-input v-model="editData.email"></el-input>
        </el-form-item>
        <el-form-item label="所属角色:">
          <span class="absPosiG">*</span>
          <div class="flexDis itemSele">
            <el-select v-model="editData.belongRole" placeholder="请选择所属角色">
              <el-option
                v-for="item in selectData"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item class="itemBtnS" style="margin-left:-50px">
          <el-button @click="cancleFn">清空</el-button>
          <el-button class="btnL" @click="sureFn">确认保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 信息上下线弹框结束 -->
    <!-- 审核提交弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      class="passDialog"
      :visible.sync="passDialogVisible"
      :before-close="passHandleClose"
      width="21%"
      center
      top="35vh"
    >
      <div class="passImg">
        <img style="width:128px;height:128px;" :src="imgUrl" alt />
      </div>
      <div class="passSucc">提交失败</div>
    </el-dialog>
    <!-- 审核提交弹框结束 -->
  </div>
</template>

<script>
import {
  getAdminUserInfoListPost,
  getAdminUserInfoPost,
  getJfyRuleListPost,
  updateAdminUserInfoPost,
  addAdminUserInfoPost,
  adminUserInfoDeletePost
} from "@/request/set.js";
import { MessageBox,Message } from 'element-ui'
export default {
  data() {
    return {
      titleType: "", // 添加修改区别
      editDialogVisible: false, // 添加管理员弹框
      passDialogVisible: false, // 提交失败弹框
      // 获取列表传参
      adminPar: {
        token: "",
        page: 1,
        page_size:10
      },
      total: 1,
      adminTable: [], // 管理员列表数据
      // 修改绑定数据
      editData: {
        UserName: "", // 用户名
        realName: "", // 真是姓名
        // post: "", // 岗位
        passWord: "", // 密码
        surePassWord: "", // 确认密码
        email: "", // Email
        belongRole: "" // 所属角色
      },
      // 修改获取数据传参
      editPar: {
        UserID: "",
        token: ""
      },
      // 修改确认传参
      editSurePar: {
        token: "",
        UserID: "", // 管理员id
        user_name: "", // 用户名
        RoleID: "", // 角色id
        E_mail: "", // E_mail
        pwd: "", // 密码
        confirm_pwd: "", // 确认密码
        Phone: "" // 手机号
      },
      selectData: [], // 下拉列表数据
      userId: "", // 存储管理员id
      imgXl: require("@/images/scenics/sj.png"),
      imgXlb: require("@/images/scenics/sjh.png"),
      imgUrl: require("@/images/scenics/sqp.png"),
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      tableData: [
    
      ],
      options: [
      
      ],
      value: "",
      radio: ""
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
    this.adminPar = {
      token: this.Token,
      page: 1,
      page_size: 10
    };
    this.getList(this.adminPar);
  },
  methods: {
    // 获取列表数据
    getList(data) {
      getAdminUserInfoListPost(data).then(res => {
        this.adminTable = res.data.result.data;
        this.total = res.data.result.total;
      });
    },
    // 获取所属角色下拉框值
    getSelect() {
      let upData = {
        token: this.Token
      };
      getJfyRuleListPost(upData).then(res => {
        console.log(res);
        this.selectData = res.data.result.data;
      });
    },
    // 修改清空
    cancleFn() {
      this.editData = {
        UserName: "", // 用户名
        realName: "", // 真是姓名
        // post: "", // 岗位
        passWord: "", // 密码
        surePassWord: "", // 确认密码
        email: "", // Email
        belongRole: "" // 所属角色
      }
      // this.editDialogVisible = false;
    },
    // 点击确认保存
    sureFn() {
      if(this.editData.passWord&&this.editData.surePassWord){
        if(this.editData.passWord!=this.editData.surePassWord){
            Message.error('两次密码不一致')
            return false
          }
      }
      if (this.userId) {
        // 修改
        this.editSurePar = {
          token: this.Token,
          UserID: this.userId, // 管理员id
          user_name: this.editData.UserName, // 用户名
          Phone:this.editData.Phone, // 手机号
          name: this.editData.realName, // 真实姓名
          RoleID: this.editData.belongRole, // 角色id
          E_mail: this.editData.email, // E_mail
          pwd: this.editData.passWord, // 密码
          confirm_pwd: this.editData.surePassWord // 确认密码
        };
        updateAdminUserInfoPost(this.editSurePar).then(res => {
          console.log(res);
          if (res.data.rcode == 200) {
            Message.success(res.data.msg);
            this.editDialogVisible = false;
            let data  = {
              token: this.Token,
            };
            this.getList(data);
          } else {
            Message.error(res.data.msg);
          }
        });
      } else {
        // 添加
        this.editSurePar = {
          token: this.Token,
          // UserID: this.userId, // 管理员id
          user_name: this.editData.UserName, // 用户名
          name: this.editData.realName, // 真实姓名
          Phone:this.editData.Phone, // 手机号
          RoleID: this.editData.belongRole, // 角色id
          E_mail: this.editData.email, // E_mail
          pwd: this.editData.passWord, // 密码
          confirm_pwd: this.editData.surePassWord // 确认密码
        };
        addAdminUserInfoPost(this.editSurePar).then(res => {
          console.log(res);
          if (res.data.rcode == 200) {
            Message.success(res.data.msg);
            this.editDialogVisible = false;
            this.adminPar = {
              token: this.Token,
              page: 1,
              page_size: 10
            };
            this.total = 0
            this.getList(this.adminPar);
          } else {
            Message.error(res.data.msg);
          }
        });
      }
      // this.passDialogVisible = true;
    },
    // 提交失败
    passHandleClose() {
      this.passDialogVisible = false;
    },
    // 删除
    delFn(row) {
      let upData = {
        UserID: row.UserID,
        token: this.Token
      };
      MessageBox("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          adminUserInfoDeletePost(upData).then(res => {
            if (res.data.rcode == 200) {
              Message({
                type: "success",
                message: res.data.msg
              });
              this.adminPar = {
                token: this.Token,
                page: 1,
                page_size: 10
              };
              this.total = 0
              this.getList(this.adminPar);
            }else{
              Message({
                type: "error",
                message: res.data.msg
              });
            }
          });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 添加修改管理员
    editFn(row) {
      if (row) {
        // 修改
        this.titleType = "修改管理员";
        this.editPar = {
          UserID: row.UserID,
          token: this.Token
        };
        this.userId = row.UserID;
        this.getSelect();
        getAdminUserInfoPost(this.editPar).then(res => {
          console.log(res);
          this.editData = {
            UserName: res.data.result.UserName, // 用户名
            realName: res.data.result.Name, // 真是姓名
            // post: res.data.result.UserName, // 岗位
            passWord: '', // 密码
            surePassWord:'', // 确认密码
            email: res.data.result.E_mail, // Email
            belongRole: Number(res.data.result.RoleID), // 所属角色
            Phone:res.data.result.Phone,
            E_mail:res.data.result.E_mail
          };
        });
      } else {
        // 添加
        this.titleType = "添加管理员";
        // 初始化数据
        this.editData = {
          UserName: "", // 用户名
          realName: "", // 真是姓名
          // post: "", // 岗位
          passWord: "", // 密码
          surePassWord: "", // 确认密码
          email: "", // Email
          belongRole: "" // 所属角色
        };
        this.getSelect();
      }
      this.editDialogVisible = true;
    },
    // 添加管理员弹框X
    editHandleClose() {
      this.editDialogVisible = false;
    },
    // 分页
    handleCurrentChange(val) {
      this.adminPar.page = val;
      this.getList(this.adminPar);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang="less" scoped>
.passDialog {
  // /deep/.el-dialog__header{
  //   height: 0;
  // }
  .passImg {
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-top: 58px;
    margin-bottom: 33px;
  }
  .passSucc {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    /* identical to box height */
    color: #000000;
    margin-bottom: 30px;
  }
}
.editForm {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  /deep/.el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #666666;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
  .itemBtnS {
    display: flex;
    justify-content: center;
    margin-top: 42px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }

  .el-form-item {
    margin-bottom: 20px;
  }
  .itemSele {
    // width: 500px;
    height: 40px;
    /deep/.el-select {
      width: 100%;
      height: 100%;
    }
  }
}

.el-form-item {
  position: relative;
}
.absPosiA {
  position: absolute;
  top: 0px;
  left: -66px;
  color: #ff4d4f;
}
.absPosiB {
  position: absolute;
  top: 0px;
  left: -78px;
  color: #ff4d4f;
}
.absPosiD {
  position: absolute;
  top: 0px;
  left: -51px;
  color: #ff4d4f;
}
.absPosiE {
  position: absolute;
  top: 0px;
  left: -78px;
  color: #ff4d4f;
}
.absPosiF {
  position: absolute;
  top: 0px;
  left: -58px;
  color: #ff4d4f;
}
.absPosiG {
  position: absolute;
  top: 0px;
  left: -78px;
  color: #ff4d4f;
}
.editCol {
  color: #ff4d4f;
}
.conentBox {
  margin-top: 17px;
  .conentRow {
    margin-bottom: 20px;
  }
}
.scenicBtn {
  height: 40px;
  display: flex;
  justify-content: flex-end;
  // margin-left: 42px;
  .el-button {
    width: 120px;
    display: flex;
    justify-content: center;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
  }
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

// 弹框
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/ .el-dialog{
  min-width: 300px;
}
</style>